import {JobStatusNotificationDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";

/**
 * Job status notification class data.
 */
export default class JobStatusNotificationData {
	/**
	 * @param {string} jobId Job Id which status was changed.
	 * @param {string} creator Entity who changed Job status.
	 * @param {string} previousStatusId Previous Job status id.
	 * @param {string} currentStatusId Current Job status id.
	 * @param {string} referenceNumber Job reference number.
	 */
	constructor(public readonly jobId: string,
		public readonly creator: AuthenticatedEntity,
		public readonly currentStatusId: string,
		public readonly previousStatusId: string,
		readonly  referenceNumber: string) {}

	static fromJson(json: JobStatusNotificationDataApiDto): JobStatusNotificationData {
		const creator = AuthenticatedEntity.fromJson(json.entity);
		return new JobStatusNotificationData(
			json.jobId,
			creator,
			json.currentStatus,
			json.previousStatus,
			json.referenceNumber);
	}
}
